import { ReactNode } from "react"
import { BRAND } from "../../constants"
import { CarouselHeightsSizes, CAROUSEL_HEIGHTS } from "../../models/types/Carousel.type"
import CarouselControls from "./CarouselControls"

type CarouselContainerProps = {
    children: ReactNode
    showButtons: any
    handleNavigate: (direction: string) => void
    size: CarouselHeightsSizes
    headingId: string
    isLarge: boolean
}

const CarouselContainer = ({ children, showButtons, handleNavigate, size, headingId, isLarge }: CarouselContainerProps) => {
  return (
    <nav className='outer-carousel' aria-labelledby={headingId}>
      <CarouselControls
        size={size}
        isLarge={isLarge}
        showButtons={showButtons}
        handleNavigate={handleNavigate}
      />
      {children}
      <style jsx>{`
        .outer-carousel {
          contain: strict;
          height: ${CAROUSEL_HEIGHTS[size].height}px;
          position: relative;
          width: 100%;
          max-width: ${BRAND.layout.content}px;
        }

        @media screen and (max-width: ${BRAND.media.small}px) {
          .outer-carousel {
            height: ${isLarge ? CAROUSEL_HEIGHTS.medium.height : CAROUSEL_HEIGHTS[size].height}px;
          }
        }
      `}</style>
    </nav>
  )
}

export default CarouselContainer